<div class="main-container" outsideClick (outsideClick)="onClickOutside()">
  <ul
    [hidden]="!listOpen"
    [ngClass]="{ 'dropdown-list': listDown, defaultOptionWidth: allowDefault }"
  >
    <icn-dropdown-item
      *ngIf="allowMultiple"
      [title]="selectAllTitle"
      [selectable]="false"
      [selected]="selectAllSelected"
      [cssClass]="'select-all-option'"
      [overrideOnClickEvent]="onSelectAllClicked.bind(this)"
    >
    </icn-dropdown-item>
    <ng-content></ng-content>
  </ul>
  <div
    class="selected-container {{ selectedContainerClass }}"
    (click)="!disabled && toggleListOpen()"
  >
    <span
      [ngStyle]="{ 'text-align': textAlign }"
      class="selected"
      *ngIf="showNothing()"
      >&nbsp;</span
    >
    <span
      [ngStyle]="{ 'text-align': textAlign }"
      class="selected placeholder"
      *ngIf="!showNothing() && isPlaceholderPresented()"
      >{{ placeholder }}</span
    >
    <span
      class="selected-multiple"
      *ngIf="!showNothing() && !isPlaceholderPresented() && allowMultiple"
    >
      <ng-container *ngFor="let item of selectedItems; let index = index">
        <div class="multiple-item-label" *ngIf="item.selectable">
          <label
            class="multiple-item-label"
            [ngStyle]="{
              color: item.textColor
            }"
            >{{ item.title }}</label
          >
          <div
            class="settingIcon settingIconSubs"
            inlineSVG="/assets/icons/pop-edit.svg"
            (click)="showSettingsIcon && onSettingsIconClicked($event, item)"
            *ngIf="showSettingsIcon"
          ></div>
          <span class="remove" (click)="onItemClicked(item)">
            <svg width="7px" height="7px" viewBox="0 0 12 12">
              <path
                fill-rule="evenodd"
                d="M10.943,9.919 L9.888,10.974 L5.939,7.024 L1.990,10.974 L0.934,9.919 L4.884,5.969 L0.934,2.020 L1.990,0.965 L5.939,4.914 L9.888,0.965 L10.943,2.020 L6.994,5.969 L10.943,9.919 Z"
              />
            </svg>
          </span>
        </div>
      </ng-container>
    </span>
    <span
      [ngStyle]="{ 'text-align': textAlign }"
      class="selected {{ selectedClass }}"
      *ngIf="
        !showNothing() &&
        !isPlaceholderPresented() &&
        !allowMultiple &&
        !!selectedItem.title
      "
      >{{ selectedItem.title }}</span
    >
    <div
      [ngStyle]="{ 'text-align': textAlign }"
      class="selected"
      *ngIf="
        !showNothing() &&
        !isPlaceholderPresented() &&
        !allowMultiple &&
        !!selectedItem.titleTemplateRef
      "
    >
      <ng-template
        [ngTemplateOutlet]="selectedItem.titleTemplateRef"
      ></ng-template>
    </div>

    <div
      *ngIf="showSettingsIcon && !allowMultiple"
      class="settingIcon settingIconSubs"
      inlineSVG="/assets/icons/pop-edit.svg"
      (click)="onSettingsIconClicked($event)"
    ></div>

    <svg width="13px" height="7px">
      <path
        fill-rule="evenodd"
        fill="rgb(135, 155, 175)"
        d="M1.047,0.499 L-0.003,1.547 L4.999,6.539 L10.001,1.547 L8.950,0.499 L4.999,4.442 L1.047,0.499 Z"
      />
    </svg>
  </div>
</div>
